/* eslint-disable import/prefer-default-export */

export function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}



// WEBPACK FOOTER //
// ./src/utils/arrayUtils.js